export const MEDCALL2_ROUTE_BASE = '/tools/medcall2';

export type MedcallProfileMutationDraft = {
  cid: string;
  dob: string;
  optionFacilityId: string;
  program: string;
  provider: string;
};

export const getMedcallProfileFacilityProgram = (
  routeBase: string,
  participantProgram: string,
  draftProgram: string,
) => {
  if (routeBase === MEDCALL2_ROUTE_BASE) {
    return participantProgram;
  }

  return draftProgram || participantProgram;
};

export const shouldShowMedcallAliasEntryFields = (
  routeBase: string,
  hasFullAccess: boolean,
) => {
  if (routeBase === MEDCALL2_ROUTE_BASE) {
    return hasFullAccess;
  }

  return true;
};

export const normalizeMedcallProfileCidDraft = (
  routeBase: string,
  value: string,
) => {
  if (routeBase === MEDCALL2_ROUTE_BASE) {
    return value.replace(/\D/g, '');
  }

  return value;
};

export const buildMedcallProfileMutationVariables = ({
  draft,
  hasFullAccess,
  participantId,
  programUsesFacility,
  routeBase,
}: {
  draft: MedcallProfileMutationDraft;
  hasFullAccess: boolean;
  participantId: number;
  programUsesFacility: boolean;
  routeBase: string;
}) => {
  const variables: Record<string, unknown> = {
    participantId,
    provider: draft.provider || null,
  };

  if (routeBase === MEDCALL2_ROUTE_BASE) {
    variables.preserveLegacySemantics = true;
  }

  if (programUsesFacility) {
    variables.optionFacilityId = Number(draft.optionFacilityId);
  }

  if (!programUsesFacility) {
    variables.optionFacilityId = null;
  }

  if (hasFullAccess) {
    variables.cid = draft.cid || null;
    variables.dob = draft.dob || null;
    variables.program = draft.program;
  }

  return variables;
};

export const getMedcallIdentityDialogCopy = (
  routeBase: string,
  pendingAction: string | null,
) => {
  if (routeBase === MEDCALL2_ROUTE_BASE) {
    return {
      dobLabel: 'DOB',
      profileDescription: null,
      profileSubmitLabel: pendingAction === 'profile' ? 'Submitting...' : 'Submit',
    };
  }

  return {
    dobLabel: 'Date of Birth',
    profileDescription: 'Update the client profile fields available for this program.',
    profileSubmitLabel: pendingAction === 'profile' ? 'Saving...' : 'Save Changes',
  };
};
